module.exports = __webpack_public_path__ + "img/board3-GPX-green-52.d63bc7cb.jpg";